module.exports = __webpack_public_path__ + "img/p2-65.51de078a.png";